<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title text-center">川閱古今</h2>

            <div
                class="detail-card blue"
                v-for="(item, index) in arMenu"
                :key="item.name"
                :class="{ 'mb-3 dotted': arMenu.length - 1 !== index }"
            >
                <div class="card-body">
                    <div class="d-flex align-items-center mb-2">
                        <div
                            class="circle mr-2 align-self-baseline flex-shrink-0"
                            v-text="index + 1"
                        >
                            1
                        </div>
                        <div class="title mr-2" v-text="item.name">
                            柳川製旗業
                        </div>
                        <button
                            v-if="item.lon || item.lat"
                            class="btn btn-how ml-auto flex-shrink-0 align-self-baseline"
                            @click="goGoogleMap([item.lon, item.lat])"
                        >
                            <img
                                src="@/assets/part_ic_inquire.png"
                                alt="如何到達"
                            />如何到達
                        </button>
                    </div>
                    <vue-load-image class="mb-2">
                        <img
                            slot="image"
                            :src="item.img"
                            :alt="item.name"
                            class="detail-img"
                        />
                        <img
                            slot="preloader"
                            src="@/assets/image-loader.gif"
                            class="w-100"
                        />
                        <img
                            slot="error"
                            class="border d-block detail-img"
                            src=""
                            alt="not found"
                        />
                    </vue-load-image>
                    <div
                        class="ref-text text-center mb-2 text-muted"
                        v-html="item.ref"
                    ></div>
                    <a
                        class="btn btn-more w-100"
                        :href="item.link"
                        target="_blank"
                    >
                        點擊進入AR畫面
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            arMenu: [
                // {
                //     name: 'demo測試',
                //     img: require('@/assets/game_img_ar_demo.png'),
                //     link:
                //         './old-and-new/AR-Yanagawa_Picture_Comparison(carousel images and Text Narration)',
                //     ref: 'test',
                //     lon: 0,
                //     lat: 0,
                // },
                {
                    name: '臺中柳川旁',
                    img: require('@/assets/臺中柳川旁.jpg'),
                    link: './old-and-new/AR-Next_To_Taichung_Yanagawa_View',
                    ref:
                        '作者：余如季。臺中柳川旁。典藏者：余立。創用CC 姓名標示-非商業性-相同方式分享 3.0台灣（CC BY-NC-SA 3.0 TW）。發佈於《開放博物館》[https://openmuseum.tw/muse/digi_object/734ea1c44fcfa1ac0b4fa9daf0bb604a#16849]（2022/06/06瀏覽）。',
                    lon: 120.677431,
                    lat: 24.143835,
                },
                {
                    name: '中山柳橋',
                    img: require('@/assets/中山柳橋.jpg'),
                    link: './old-and-new/AR-Yanagawa_Nakayama_Yanagibashi',
                    ref:
                        '作者：余如季。中山柳橋。典藏者：余立。創用CC 姓名標示-非商業性-相同方式分享 3.0台灣（CC BY-NC-SA 3.0 TW）。發佈於《開放博物館》[https://openmuseum.tw/muse/digi_object/dceeb3a6bfefe16a02b64fbf5b57789f#16138]（2022/06/06瀏覽）。',
                    lon: 120.677288,
                    lat: 24.142955,
                },
                {
                    name: '柳川空拍',
                    img: require('@/assets/柳川空拍.jpg'),
                    link: './old-and-new/AR-Aerial_View_of_Yanagawa',
                    ref:
                        '作者:余如季。授權者:余立。參考資料:主編詹秀珠(2020)。《臺中夢的苦難與輝煌》',
                    lon: 120.675708,
                    lat: 24.141591,
                },
                {
                    name: '柳川吊腳樓一景',
                    img: require('@/assets/柳川吊腳樓一景.jpg'),
                    link:
                        './old-and-new/AR-A_Scene_of_Yanagawa_Stilted_Building',
                    ref:
                        '作者：余如季。柳川吊腳樓一景。典藏者：余立。創用CC 姓名標示-非商業性-相同方式分享 3.0台灣（CC BY-NC-SA 3.0 TW）。發佈於《開放博物館》[https://openmuseum.tw/muse/digi_object/8e677a972ad01feda92229158d0c954d#16842]（2022/06/06瀏覽）。',
                    lon: 120.673627,
                    lat: 24.141007,
                },
                {
                    name: '義務勞動',
                    img: require('@/assets/義務勞動.jpg'),
                    link: './old-and-new/AR-Yanagawa_Voluntary_Labor',
                    ref:
                        '作者：余如季。義務勞動。典藏者：余立。創用CC 姓名標示-非商業性-相同方式分享 3.0台灣（CC BY-NC-SA 3.0 TW）。發佈於《開放博物館》[https://openmuseum.tw/muse/digi_object/24fef9473531fe29836d57d2290c88c0#16229]（2022/06/06瀏覽）。',
                    lon: 120.672705,
                    lat: 24.14056,
                },
                {
                    name: '林森路下游',
                    img: require('@/assets/林森路下游.jpg'),
                    link: './old-and-new/AR-Downstream_of_Linsen_Road',
                    ref:
                        '作者：余如季。林森路下游。典藏者：余立。創用CC 姓名標示-非商業性-相同方式分享 3.0台灣（CC BY-NC-SA 3.0 TW）。發佈於《開放博物館》[https://openmuseum.tw/muse/digi_object/4480d52a07a872054ab08c0b2246ea14#16153]（2022/06/06瀏覽）。',
                    lon: 120.670122,
                    lat: 24.139393,
                },
                {
                    name: '無尾巷，有39戶的吊腳樓',
                    img: require('@/assets/無尾巷，有39戶的吊腳樓.jpg'),
                    link:
                        './old-and-new/AR-No_Tail_Alley_With_39_Stilted_Buildings',
                    ref: `作者:余如季。授權者:余立。參考資料:主編詹秀珠(2020)。《臺中夢的苦難與輝煌》。
`,
                    lon: 120.681483,
                    lat: 24.134721,
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
